import { render } from "./smsForm.vue?vue&type=template&id=6c670862"
import script from "./smsForm.vue?vue&type=script&lang=js"
export * from "./smsForm.vue?vue&type=script&lang=js"

import "./smsForm.vue?vue&type=style&index=0&id=6c670862&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__